import styled from 'styled-components';
import type {ModalType} from './index';

export const Overlay = styled.div<{zIndex: number}>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: ${(props) => props.zIndex};
`;

export const Container = styled.div<{type: string}>`
    background: white;
    border-radius: 8px;
    padding: 24px;
    max-width: 400px;
    width: 90%;
    border-left: 4px solid
        ${(props) => {
            switch (props.type) {
                case 'success':
                    return '#28a745';
                case 'warning':
                    return '#ffc107';
                case 'error':
                    return '#dc3545';
                case 'confirm':
                    return '#007bff';
                default:
                    return '#17a2b8';
            }
        }};
`;

export const Title = styled.h3`
    margin: 0 0 12px 0;
    font-size: 18px;
    font-weight: 600;
`;

export const Message = styled.p`
    margin: 0 0 24px 0;
    color: #666;
    line-height: 1.5;
`;

export const ButtonGroup = styled.div`
    display: flex;
    justify-content: center;
    gap: 12px;
`;

const typeColor: Record<ModalType, string> = {
    info: '#3498db',
    success: '#2ecc71',
    error: '#e74c3c',
    warning: '#f39c12',
    confirm: '#9b59b6',
};

export const Button = styled.button<{colorType?: ModalType}>`
    background-color: ${({colorType}) => typeColor[colorType || 'info']};
    color: ${(props) => (props.colorType === 'warning' ? '#000' : '#fff')};
    border: none;
    border-radius: 6px;
    padding: 8px 16px;
    cursor: pointer;
    font-size: 15px;
    font-weight: bold;
    transition: all 0.2s;

    &:hover {
        opacity: 0.9;
        transform: translateY(-1px);
    }
`;
